import React from "react";
import { Link } from "react-router-dom";
import ScrollAnimation from "../components/animations/ScrollAnimation";

const Footer = () => {
  return (
    <section className="bg-white">
      <div className="h-1 bg-gradient-to-r from-[#F9CB4E] to-white w-full"></div>
      <div className="max-w-[1500px] mx-auto lg:flex lg:items-center lg:justify-between">
        <div className="flex flex-col items-center justify-center py-10 space-y-10 text-black lg:flex-row lg:justify-between lg:px-10 lg:py-20 lg:w-5/12">
          <div className="flex flex-col space-y-5 text-center lg:space-y-0 lg:flex-row lg:space-x-10 lg:text-left">
            <ScrollAnimation
              direction="left"
              delay={0.5}>
              <div className="flex flex-col space-y-2 text-2xl lg:text-4xl font-bold lg:leading-[60px]">
                Sacarabany SARL, expert en électricité batiments industriels et
                climatisation
              </div>
            </ScrollAnimation>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center py-10 space-y-10 text-black lg:flex-row lg:justify-between lg:px-10 lg:py-20 lg:w-5/12">
          <div className="flex flex-col space-y-5 text-center lg:space-y-0 lg:flex-row lg:space-x-10 lg:text-left lg:gap-x-12 gap-y-4">
            <ScrollAnimation
              direction="left"
              delay={0.5}>
              <div className="flex flex-col space-y-2">
                <h3 className="text-sm lg:text-base font-semibold text-primary-blue">
                  pages
                </h3>
                <Link
                  to="/a-propos"
                  className="text-base lg:text-lg font-medium">
                  A propos
                </Link>
                <Link
                  to="/realisations"
                  className="text-base lg:text-lg font-medium">
                  Réalisations
                </Link>
                <Link
                  to="/contactez-nous"
                  className="text-base lg:text-lg font-medium">
                  Faire un devis
                </Link>
              </div>
            </ScrollAnimation>
            {/* Si on décommente cette partie, on doit faire passer le bloc le bloc en lg:w-7/12 à la place de lg:w-5/12 */}
            {/* <ScrollAnimation
              direction="left"
              delay={0.5}>
              <div className="flex flex-col space-y-2">
                <h3 className="text-sm lg:text-base font-semibold text-primary-blue">expertises</h3>
                <p className="text-base lg:text-lg font-medium">Électricité</p>
                <p className="text-base lg:text-lg font-medium">Climatisation</p>
              </div>
            </ScrollAnimation> */}
            <ScrollAnimation
              direction="left"
              delay={0.5}>
              <div className="flex flex-col space-y-2">
                <h3 className="text-sm lg:text-base font-semibold text-primary-blue">
                  contact
                </h3>
                <p className="text-base lg:text-lg font-medium">
                  Un besoin, un projet, une remarque ?
                </p>
                <Link
                  to="/contactez-nous"
                  className="text-base lg:text-lg font-bold">
                  hello@sacarabany-sarl.fr
                </Link>
              </div>
            </ScrollAnimation>
          </div>
        </div>
      </div>
      <div className="pb-10 bg-[#F3FAFF]">
        <div className="max-w-[1500px] mx-auto">
          {/* footer */}
          <div className="flex  flex-col space-y-6  pt-10  text-black pl-10 w-[270px] self-end lg:flex-row lg:justify-between lg:w-full lg:px-10 lg:space-y-0 ">
            <ScrollAnimation
              direction="left"
              delay={0.5}>
              <p className="text-base font-medium">
                (c) Sacarabany SARL 2024 - Design by Novwell 🚀
              </p>
            </ScrollAnimation>
            <div className="flex flex-col space-y-1 text-black lg:flex-row lg:space-x-3 lg:space-y-0 lg:text-base">
              {/* <ScrollAnimation
                direction="right"
                delay={0.5}>
                <Link to="/politique-de-cookies">Politique de cookies</Link>
              </ScrollAnimation> */}
              <ScrollAnimation
                direction="right"
                delay={0.5}>
                <Link to="/politique-de-confidentialite">
                  Mentions légales et Politique de confidentialité
                </Link>
              </ScrollAnimation>
              {/* <ScrollAnimation
                direction="right"
                delay={0.5}>
                <Link to="/mentions-legales">Mentions légales</Link>
              </ScrollAnimation> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
